module.exports = __webpack_public_path__ + "img/AT0000043990728.1e8a5110.png";